<template>
    <v-dialog :value="value" max-width="520" :fullscreen="$vuetify.breakpoint.xsOnly"
        transition="scale-transition" @input="$emit('input', $event)">
        <div class="module-search">
            <div class="module-search__field">
                <i class="fas fa-search" aria-hidden="true"></i>
                <input ref="field" v-model="query" type="text" placeholder="Buscar módulo"
                    aria-label="Buscar módulo" autocomplete="off"
                    @keydown.down.prevent="move(1)" @keydown.up.prevent="move(-1)"
                    @keydown.enter.prevent="go(results[current])">
                <button type="button" class="module-search__close" aria-label="Cerrar" @click="close">
                    <i class="fas fa-times" aria-hidden="true"></i>
                </button>
            </div>
            <ul v-if="results.length" class="module-search__list" role="listbox">
                <li v-for="(link, index) in results" :key="link.key" role="option"
                    :aria-selected="String(index === current)">
                    <button type="button" class="module-search__item"
                        :class="{ 'is-current': index === current }"
                        @mouseenter="current = index" @click="go(link)">
                        <i :class="link.icon" aria-hidden="true"></i>
                        <span class="module-search__text">{{ link.text }}</span>
                        <span v-if="link.group" class="module-search__group">{{ link.group }}</span>
                    </button>
                </li>
            </ul>
            <p v-else class="module-search__empty">No hay módulos que coincidan con la búsqueda.</p>
        </div>
    </v-dialog>
</template>
<script>
import { flattenNav, searchNav } from '@/service/permiso/menuModel';

/**
 * Buscador de módulos (Ctrl K): salta a cualquier pantalla del menú del rol.
 * Usa la misma lista que el drawer, así que cada rol solo encuentra lo que ya ve.
 * Flechas y Enter para moverse; Esc cierra (lo da el diálogo).
 */
export default {
    name: 'ModuleSearch',
    props: {
        value: { type: Boolean, default: false },
        nav: { type: Array, default: () => [] }
    },
    data() {
        return { query: '', current: 0 };
    },
    computed: {
        results() {
            return searchNav(flattenNav(this.nav), this.query);
        }
    },
    watch: {
        query() {
            this.current = 0;
        },
        value(open) {
            if (!open) return;
            this.query = '';
            this.current = 0;
            // el contenido del diálogo se pinta después de abrir
            this.$nextTick(() => requestAnimationFrame(() => {
                if (this.$refs.field) this.$refs.field.focus();
            }));
        }
    },
    methods: {
        move(step) {
            const total = this.results.length;
            if (!total) return;
            this.current = (this.current + step + total) % total;
        },
        close() {
            this.$emit('input', false);
        },
        go(link) {
            if (!link) return;
            this.close();
            this.$router.push(link.to).catch(() => {});
        }
    }
};
</script>
<style scoped>
.module-search {
    display: flex;
    flex-direction: column;
    max-height: 70vh;
    background: var(--app-surface);
    border-radius: 8px;
    overflow: hidden;
}
.module-search__field {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0 8px 0 16px;
    height: 52px;
    border-bottom: 1px solid var(--app-line);
    color: var(--app-text-muted);
}
.module-search__field input {
    flex: 1;
    min-width: 0;
    height: 100%;
    border: 0;
    outline: 0;
    background: transparent;
    color: var(--app-text);
    font: inherit;
    font-size: 16px;
}
.module-search__close {
    width: 40px;
    height: 40px;
    border: 0;
    border-radius: 50%;
    background: transparent;
    color: inherit;
    cursor: pointer;
}
.module-search__close:hover {
    background: var(--app-hover);
}
.module-search__list {
    margin: 0;
    padding: 8px;
    list-style: none;
    overflow-y: auto;
}
.module-search__item {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    min-height: 44px;
    padding: 0 12px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: var(--app-text);
    font: inherit;
    font-size: 14px;
    text-align: left;
    cursor: pointer;
}
.module-search__item.is-current {
    background: var(--app-primary-soft);
    color: var(--app-primary);
}
.module-search__item i {
    flex: 0 0 18px;
    text-align: center;
}
.module-search__text {
    flex: 1;
    min-width: 0;
}
.module-search__group {
    font-size: 12px;
    color: var(--app-text-muted);
}
.module-search__empty {
    margin: 0;
    padding: 24px 16px;
    font-size: 14px;
    color: var(--app-text-muted);
}
</style>
